import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import AddIcon from "@mui/icons-material/Add";

import { toast } from "react-toastify";
import axiosInstance from "../../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const SpecificationType = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const superuserId = localStorage.getItem("is_superuser");
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);

  const [specificationDataList, setSpecificationDataList] = useState([]);
  const [page, setPage] = useState(1);

  // add product varient start
  const [specificationId, setSpecificationId] = useState("");
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [name, setName] = useState("");

  // add product varient end

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const specificationTypeData = () => {
    axiosInstance
      .get(
        `api/admin/product-specifications-type-list/?store_id=${storeId}&page=${page}&search=${searchQuery}`,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setData(response?.data?.data);
        console.log("specification type====>", response?.data);
        setTotalPage(response?.data?.current_page);
        setCurrentPage(response?.data?.total_pages);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    specificationTypeData();
  }, [page, searchQuery]);

  const specificationData = () => {
    axiosInstance
      .get(`api/admin/product-specifications-list/?store_id=${storeId}`, {
        headers: {
          Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setSpecificationDataList(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    specificationData();
  }, []);

  const submitCategory = () => {
    const reqbody = new FormData();
    reqbody.append("product_specification_id", specificationId);
    reqbody.append("specification_type", name);

    ids == null
      ? axiosInstance
          .post(
            `api/admin/product-specifications-type-list/?store_id=${storeId}`,
            reqbody,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            toast.success(response.data.message);
            specificationTypeData();
            setName("");
            setSpecificationId("");
            setIds(null);
            handleClose();
          })
          .catch((error) => {
            console.log("", error);
          })
      : axiosInstance
          .put(
            `api/admin/product-specifications-type-list/?store_id=${storeId}&product_specification_type_id=${ids}`,
            reqbody,
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            toast.success(response.data.message);
            setRowData({});
            setName("");
            setIds(null);
            specificationTypeData();
            handleClose();
          })
          .catch((error) => {
            console.log("", error);
          });
  };

  const previousPage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  };
  const nestPage = () => {
    setPage(page + 1);
  };

  const hangleCancel = () => {
    setRowData();
    setIds(null);
    setName("");
    setSpecificationId("");
    handleClose();
  };

  const editFunctionality = (row) => {
    setIds(row?.id);
    setName(row?.specification_type);
    setRowData(row);
    handleOpen();
  };

  const deleteProduct = (event, id) => {
    event.preventDefault();

    const deleteData = window.confirm(
      "are you sure delete this product specification Type...!",
    );

    if (deleteData == true) {
      axiosInstance
        .delete(
          `api/admin/product-specifications-type-list/?store_id=${storeId}&product_specification_type_id=${id}`,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          },
        )
        .then((response) => {
          toast.success(response.data.message);
          specificationTypeData();
        })
        .catch((error) => {
          console.log("error page", error.response);
          console.log(error);
        });
    }
  };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Product Specification Type List
          </p>
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" color="primary" onClick={handleOpen}>
            <AddIcon />
            Add Product Specification Type
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              value={searchQuery}
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 430 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids === null
                      ? "Add Product Specification Type"
                      : "Update Product Specification Type"}
                  </div>
                  <div className="w-full">
                    {ids === null ? (
                      <>
                        <div className="">Select Specification :</div>
                        <FormControl fullWidth>
                          <Select
                            id="demo-simple-select"
                            size="small"
                            name="main_category_id"
                            className="!mt-1"
                            value={specificationId}
                            onChange={(event) =>
                              setSpecificationId(event.target.value)
                            }
                          >
                            {specificationDataList?.map((elem) => (
                              <MenuItem value={elem?.id}>
                                {elem?.specification_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </>
                    ) : null}

                    <div className="mt-2">Specification Type :</div>
                    <input
                      size="small"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                      id="outlined-basic"
                      className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
                      name="product_name"
                    />
                  </div>
                  <Button
                    onClick={hangleCancel}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids == null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>

                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SPECIFICATION HEADING
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SPECIFICATION TYPE
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.product_specification?.specification_name
                        ? row?.product_specification?.specification_name
                        : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.specification_type ? row?.specification_type : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <BorderColorIcon
                        className="text-green-400 mx-2"
                        onClick={() => editFunctionality(row)}
                      />
                      <DeleteForeverIcon
                        className="text-red-500 mx-2"
                        onClick={(event) => deleteProduct(event, row?.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            {currentPage}...{totalPage}
            <ArrowForwardIosIcon onClick={nestPage} />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon onClick={previousPage} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecificationType;
